export type HeatmapRenderConfig = {
  interpolationScale: number;
  softBlurPx: number;
  spatialSmoothingPasses: number;
  updateIntervalSeconds: number;
  temporalSmoothing: number;
  imageSmoothingQuality: ImageSmoothingQuality;
};

export const HEATMAP_OPACITY = 0.7;
export const HEATMAP_STABILITY_EPSILON = 0.125;

export const DEFAULT_HEATMAP_RENDER_CONFIG: HeatmapRenderConfig = {
  interpolationScale: 3,
  softBlurPx: 5,
  spatialSmoothingPasses: 2,
  updateIntervalSeconds: 0.1,
  temporalSmoothing: 0.05,
  imageSmoothingQuality: "high",
};

export const VR_HEATMAP_RENDER_CONFIG: HeatmapRenderConfig = {
  interpolationScale: 2,
  softBlurPx: 3,
  spatialSmoothingPasses: 1,
  updateIntervalSeconds: 0.1,
  temporalSmoothing: 0.14,
  imageSmoothingQuality: "medium",
};
